"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndustrialCenter = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const TileType_1 = require("../../TileType");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const Board_1 = require("../../boards/Board");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const CardRenderer_1 = require("../render/CardRenderer");
class IndustrialCenter extends Card_1.Card {
    constructor(name = CardName_1.CardName.INDUSTRIAL_CENTER, adjacencyBonus = undefined, metadata = {
        cardNumber: '123',
        renderData: CardRenderer_1.CardRenderer.builder((b) => {
            b.action('Spend 7 M€ to increase your steel production 1 step.', (eb) => {
                eb.megacredits(7).startAction.production((pb) => pb.steel(1));
            }).br;
            b.tile(TileType_1.TileType.INDUSTRIAL_CENTER, true, false).asterix();
        }),
        description: 'Place this tile adjacent to a city tile.',
    }) {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name,
            tags: [Tags_1.Tags.BUILDING],
            cost: 4,
            adjacencyBonus,
            metadata,
        });
    }
    getAvailableSpaces(player) {
        return player.game.board.getAvailableSpacesOnLand(player)
            .filter((space) => player.game.board.getAdjacentSpaces(space).some((adjacentSpace) => Board_1.Board.isCitySpace(adjacentSpace)));
    }
    canPlay(player) {
        return this.getAvailableSpaces(player).length > 0;
    }
    play(player) {
        return new SelectSpace_1.SelectSpace('Select space adjacent to a city tile', this.getAvailableSpaces(player), TileType_1.TileType.INDUSTRIAL_CENTER, (foundSpace) => {
            player.game.addTile(player, foundSpace.spaceType, foundSpace, { tileType: TileType_1.TileType.INDUSTRIAL_CENTER });
            foundSpace.adjacency = this.adjacencyBonus;
            return undefined;
        });
    }
    canAct(player) {
        return player.canAfford(7);
    }
    action(player) {
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 7, { title: 'Select how to pay for action' }));
        player.addProduction(Resources_1.Resources.STEEL, 1);
        return undefined;
    }
}
exports.IndustrialCenter = IndustrialCenter;
//# sourceMappingURL=IndustrialCenter.js.map